import request from '@/plugins/axios'

// ข้อมูลโต๊ะทำงาน 
export const apiWorkbenchIndex = () => request.get('/workbench/index')

// รายการสินค้า 
export const apiWorkbenchTopAmount = (params: any) => request.get('workbench/topAmount', params)

// รายชื่อผู้ใช้ 
export const apiWorkbenchTopUser = (params: any) => request.get('/workbench/topUser', params)

// ตรวจสอบการอัปเดต
export const apiCheckRefresh = (params?: any) => request.get('/workbench/checkVersion', params)

// ตรวจสอบของแท้
export const apiCheckLegal = (params?: any) => request.get('/workbench/checkLegal', params)
